




import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { IVideo } from "@/models/video.entity";
import { MuxPlayer } from "@/shims-mux-videojs-kit";
import { ConfigModule } from "@/store/modules/config";
import videojs from "@mux/videojs-kit";
import "@mux/videojs-kit/dist/index.css";

@Component({})
class MediaGalleryVideoPlayer extends Vue {
  @Prop({ required: true }) readonly value!: IVideo;

  player: MuxPlayer | null = null;

  get playerId(): string {
    return `video-el-${this.value.id}`;
  }

  async mounted() {
    if (this.value && this.value.hasAsset) {
      await this.$nextTick();
      this.mountPlayer();
    }
  }

  @Watch("value.hasAsset")
  async onHasAssetChanged(hasAsset: boolean) {
    if (hasAsset) {
      await this.$nextTick();
      this.mountPlayer();
    } else {
      this.destroyPlayer();
    }
  }

  mountPlayer() {
    this.player = videojs(this.playerId, {
      plugins: {
        mux: {
          debug: ConfigModule.debug,
          disableCookies: true
        }
      },
      controls: true
    });

    if (this.player) {
      this.player.src({
        src: this.value.videoJsSrc,
        type: "video/mux"
      });

      this.player.mux.emit("videochange", {
        env_key: this.value.environment
      });
    }
  }

  private destroyPlayer() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
      return;
    }

    const p = videojs.getPlayer?.(this.playerId);
    if (p) p.dispose();
  }

  async beforeDestroy() {
    this.destroyPlayer();
  }
}

export default MediaGalleryVideoPlayer;
